export default __webpack_public_path__ + "static/media/HelveticaNeue Light.2d7491fe.ttf";